define("shared/modifiers/animate-typewriter", ["exports", "@ember/debug", "@ember/runloop", "ember-modifier"], function (_exports, _debug, _runloop, _emberModifier) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/debug",0,"@ember/runloop",0,"ember-modifier"eaimeta@70e063a35619d71f

  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

  var _animateText = /*#__PURE__*/new WeakSet();

  var _containsOnlyTextNodes = /*#__PURE__*/new WeakSet();

  /**
   * This modifier adds a 'typewriter' animation to text contained within an HTMLElement
   *
   * Positional and Named parameters are outlined in the TypeScript interface above.
   *
   * Simple Usage:
   *
   * ```
   * <div {{animate-typewriter speed=100}}>
   *   Some text that I'd like animated
   * </div>
   * ```
   */
  class AnimateTypewriterModifier extends _emberModifier.default {
    constructor() {
      super(...arguments);

      _classPrivateMethodInitSpec(this, _containsOnlyTextNodes);

      _classPrivateMethodInitSpec(this, _animateText);

      _defineProperty(this, "timers", []);
    }

    modify(element, _positional, _ref) {
      let {
        speed = 100
      } = _ref;
      (false && !(_classPrivateMethodGet(this, _containsOnlyTextNodes, _containsOnlyTextNodes2).call(this, element)) && (0, _debug.assert)(`element must only contain text nodes`, _classPrivateMethodGet(this, _containsOnlyTextNodes, _containsOnlyTextNodes2).call(this, element)));
      const text = element.innerText.trim();
      element.innerText = '';
      const timer = (0, _runloop.scheduleOnce)('afterRender', this, _classPrivateMethodGet(this, _animateText, _animateText2), element, text, speed);
      this.timers.push(timer);
    }

    willRemove() {
      this.timers.forEach(timer => (0, _runloop.cancel)(timer));
    }

  }

  _exports.default = AnimateTypewriterModifier;

  function _animateText2(element, text, speed) {
    if (element && element.innerHTML.length < text.length) {
      element.innerHTML += text.charAt(element.innerHTML.length);
      const timer = (0, _runloop.later)(this, _classPrivateMethodGet(this, _animateText, _animateText2), element, text, speed, speed);
      this.timers.push(timer);
    }
  }

  function _containsOnlyTextNodes2(element) {
    const nodeArray = Array.from(element.childNodes);
    return nodeArray.every(node => node.nodeType === Node.TEXT_NODE);
  }
});